import CircleIcon from '@mui/icons-material/Circle'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { IconButton, Stack } from '@mui/material'

type OwnProps = {
  opacity?: number
  disabled?: boolean
  title: {
    delete: string
    read: string
  }
  onDelete: () => void
  onRead: () => void
}

function NotificationTools({
  opacity = 0,
  disabled,
  title,
  onDelete,
  onRead,
}: OwnProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        opacity,
      }}
    >
      <IconButton disabled={disabled} size="small" onClick={onRead}>
        <CircleIcon
          color={disabled ? 'disabled' : 'primary'}
          sx={{ height: '8px' }}
          titleAccess={title.read}
        />
      </IconButton>
      <IconButton disabled={disabled} size="small" onClick={onDelete}>
        <DeleteOutlinedIcon
          color={disabled ? 'disabled' : 'primary'}
          titleAccess={title.delete}
        />
      </IconButton>
    </Stack>
  )
}

export default NotificationTools
